import { render, staticRenderFns } from "./AdName.ts.vue?vue&type=template&id=ab2281d2"
import script from "./AdName.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdName.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports